import React, { Component } from 'react';
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import ElasticSearchService from "../../services/elasticSearch.service";
import { personName, checkDataExist, renderDateFromdateParts, checkArray, personIds, tombstoneNumbers } from '../../helpers/util'
import TombstoneGalery from "../../components/tombstoneGalery2"
import DetailElement from "../../components/detailElement"
import DetailElementBiografie from "../../components/detailElementBiografie"
import DetailElementPersonWithLink from "../../components/detailElementPersonWithLink"
import DetailElementListValues from "../../components/detailElementListValues"
import DetailElementLiteraturListValues from "../../components/detailElementLiteraturListValues"
import DetailElementZitate from "../../components/detailElementZitate"
import DetailElementStylistic from "../../components/detailElementStylistic"
import DetailElementChoices from "../../components/detailElementChoices"
import DetailElementMasse from "../../components/detailElementMasse"
import DetailElementMaterial from "../../components/detailElementMaterial"
import DetailElementInscription from "../../components/detailElementInscription"
import NavigationButton from "../../components/navigationButton"
import DetailElementChildren from "../../components/detailElementChildren"
import AuthService from "../../services/auth.service";
import FootnoteLabel from "../management/footnotes/footnoteLabel";
import ReferencesList from "../management/footnotes/referencesList";
import TombstoneMapDetailElement from "./details/tombstoneMapDetailElement2";
import ACService from "../../helpers/accessValidation.js"
import * as Constants from "../../components/constants";
import { handleStorage } from '../../helpers/jfb';




export default class TombstoneDetailsPublic extends Component {

	constructor(props) {
		super(props);

		this.state = {
			cementries: [],
			cementery: {},
			cementryName: "",
			cementryId: "",
			tombstoneId: "",
			tombstone: {},
			tombstones: [],
			tombstoneMarker: [],
			isTombstoneLoading: true,
			isLoadingTombstones: true,
			isCementryLoading: true,
			isNeighborsLoading: true,
			currentPerson: {},
			persons: [],
			previousTombstone: "",
			nextTombstone: "",
			user: "",
			googleMapConsent: false,

		}

		this.getCementryName = this.getCementryName.bind(this);
		this.getLinkFromText = this.getLinkFromText.bind(this);

	}

	getLinkFromText(text) {


		// URLs erkennen und umwandeln
		const linkifiedText = text.split(' ').map((word, index) => {
			const urlPattern = new RegExp('^(https?:\\/\\/)?' + // protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
				'(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
			const isUrl = urlPattern.test(word);
			return isUrl ? <a key={index} href={word} target="_blank" rel="noopener noreferrer">{word}</a> : <span key={index}>{word} </span>;
		});

		return linkifiedText;
	}


	scrollToInscriptionHash() {
		const hash = window.location.hash;
		if (!hash) {
			return;
		}
		const target = document.getElementById(hash.substring(1));
		if (target) {
			target.scrollIntoView({ behavior: "smooth", block: "start" });
			return;
		}
		window.setTimeout(() => {
			const retry = document.getElementById(hash.substring(1));
			if (retry) {
				retry.scrollIntoView({ behavior: "smooth", block: "start" });
			}
		}, 150);
	}

	getCementryName(cementries) {
		let cementery = cementries.find(cementry => cementry.id === this.state.cementryId);
		this.setState({
			cementryName: cementery.name,
			cementery: cementery
		});
	}

	componentDidMount() {

		const googleMapConsent = handleStorage("googleMapConsent");

		this.setState({
			googleMapConsent: googleMapConsent,
		});

		const user = AuthService.getCurrentUser();
		if (user) {
			this.setState({
				user: user,
			});
		}

		let url = window.location.href.split('/')
		let cementryId = url[4];
		let tombstoneId = url[5] ? url[5].split('#')[0].split('?')[0] : url[5];

		this.setState({
			cementryId: cementryId,
			tombstoneId: tombstoneId,
		});

		if (cementryId === Constants.TEST_CEMENTERY_ID && !ACService.canSeeTestCementery(user)) {
			this.setState({
				isTombstoneLoading: false,
				isCementryLoading: false,
				isNeighborsLoading: false,
				isLoadingTombstones: false,
				error: "Dieser Friedhof ist nicht verfügbar."
			});
			return;
		}




		ElasticSearchService.loadCementries().then(
			response => {
				const cementries = ACService.filterVisibleCementeries(response.data, user);
				this.getCementryName(cementries);
				this.setState({
					cementries: cementries,
					isCementryLoading: false
				});
			},
			error => {
				this.setState({
					error:
						(error.response && error.response.data) ||
						error.message ||
						error.toString()
				});
			}
		);

		ElasticSearchService.loadTombstoneNeighbors(cementryId, tombstoneId).then(
			response => {
				let neighbors = response.data;
				this.setState({
					previousTombstone: neighbors.previous,
					nextTombstone: neighbors.next,
					isNeighborsLoading: false
				});

			},
			error => {
				this.setState({
					error:
						(error.response && error.response.data) ||
						error.message ||
						error.toString()
				});
			}
		);

		ElasticSearchService.loadTombstone(cementryId, tombstoneId).then(
			response => {

				let data = response.data;
				let persons = data.persons;
				this.setState({
					tombstone: data,
					persons: persons,
					currentPerson: persons[0],
					secondPerson: persons[1],
					isTombstoneLoading: false,
					tombstoneMarker: [data],

				}, () => this.scrollToInscriptionHash());
			},
			error => {
				this.setState({
					error:
						(error.response && error.response.data) ||
						error.message ||
						error.toString()
				});
			}
		);

		ElasticSearchService.loadTombstones(cementryId).then(
			response => {
				this.setState({
					tombstones: response.data.tombstones,
					isLoadingTombstones: false,
				});

			},
			error => {
				this.setState({
					error:
						(error.response && error.response.data) ||
						error.message ||
						error.toString(),
					isLoadingTombstones: false,
				});
			}
		);

	}



	render() {
		const { user, tombstone, tombstones, isLoadingTombstones, tombstoneMarker, currentPerson, secondPerson, isCementryLoading, isNeighborsLoading, isTombstoneLoading, cementryId, tombstoneId, cementryName, previousTombstone, nextTombstone, cementery, googleMapConsent } = this.state;
		return (
			<Container fluid="xxl">
				<div className="text-spacer">
					<Row className="top-spacer">
						<Col>
							<Breadcrumb className="breadcrumb-style">
								<Breadcrumb.Item href="/">Home</Breadcrumb.Item>
								<Breadcrumb.Item href={'/cemetery/' + cementryId} >{cementryName}</Breadcrumb.Item>
								<Breadcrumb.Item href="/tombstones"> Grabsteinliste</Breadcrumb.Item>
								<Breadcrumb.Item active> Grabstein-ID {tombstoneId}</Breadcrumb.Item>
							</Breadcrumb>
						</Col>
					</Row>
					{!isCementryLoading && !isNeighborsLoading && !isTombstoneLoading && !isLoadingTombstones ? (<div>
						<Row>
							<Col>
							</Col>
						</Row>
						<Row>
							<Col className="col-auto me-auto">
								<a href="/tombstones">zurück zur Liste</a>
							</Col>
							<Col className="col-auto">
								<NavigationButton title="Vorheriger" linkBase="tombstoneDetails" cementryId={cementryId} tombstoneId={previousTombstone} myStyle="btn badge-flat" />
								<NavigationButton title="Nächster" linkBase="tombstoneDetails" cementryId={cementryId} tombstoneId={nextTombstone} myStyle="btn badge-flat" />
							</Col>
							<Col className="col-auto">
								{(ACService.accessValidation(user, Constants.AC_ADMIN_NAVIGATION) || ACService.accessValidation(user, Constants.AC_MANAGER_NAVIGATION)) && (
									<a href={"/management/tombstone/" + cementryId + "/" + tombstoneId} className="btn badge-flat" >Grabstein bearbeiten</a>
								)}
							</Col>
						</Row>

						<Row>
							<Col>
								<strong>Grabstein-ID: {tombstoneId} | Personen-ID: {personIds(tombstone)} </strong><br />

							</Col>
						</Row>
						<Row>
							<Col >
								{tombstone.persons.length <= 2 ? (
									<h2>
										{tombstone.persons.map((person, id) => (
											<span key={id}>{personName(person)}<br /></span>
										))}
									</h2>
								) : (
									<h4>
										{tombstone.persons.map((person, id) => (
											<span key={id}>{personName(person)}<br /></span>
										))}
									</h4>
								)}
							</Col>
						</Row>

						<Row>
							<Col>
								<hr />
							</Col>
						</Row>
						{checkArray(tombstone.tombstoneNumbers) ?
							<Row>
								<Col md={4}>
									<strong>Weitere Grabsteinnummern:</strong>
								</Col>
								<Col>
									{tombstone.tombstoneNumbers.map((entry, id) => (<span key={id}>{entry.nummer} {entry.kommentar}<br /></span>))}
								</Col>
							</Row>
							: ""}
						{checkArray(tombstone.carvedTombstoneNumber) ?
							<Row>
								<Col md={4}>
									<strong>Eingemeißelte Grabsteinnummer:</strong>
								</Col>
								<Col>
									{tombstone.carvedTombstoneNumber}
								</Col>
							</Row>
							: ""}

						{tombstone.bilder.length ? <TombstoneGalery photos={tombstone.bilder} /> : null}

						<Row>
							<Col>
								<hr />
							</Col>
						</Row>


						{tombstone.weltkoordinaten && tombstone.weltkoordinaten.features && tombstone.weltkoordinaten.features.length > 0 ? (



							<Row>
								<Col>
									{googleMapConsent ? (
										<TombstoneMapDetailElement cementery={cementery} tombstones={tombstones} zoom={20} tombstoneMarker={tombstoneMarker} />
									) : (
										<div className="consent-info" >{Constants.consentText}<br />
											<strong>Den Button finden Sie unten auf dieser Seite!</strong></div>
									)}


								</Col>
							</Row>
						) : (
							<Row>
								<Col>
									Derzeit sind keine GEO Informationen verfügbar.
								</Col>
							</Row>
						)}
						<Row>
							<Col>
								<hr />
							</Col>
						</Row>


						{tombstone.persons.map((currentPerson, id) => (<div>

							<DetailElementPersonWithLink name="Name" value={currentPerson} />
							<DetailElement name="Geburtsdatum" value={renderDateFromdateParts(currentPerson.geburtsdatum_jahr, currentPerson.geburtsdatum_monat, currentPerson.geburtsdatum_tag)} />
							<DetailElement name="Geburtsort" value={currentPerson.herkunftsort} />
							<DetailElement name="Sterbedatum" value={renderDateFromdateParts(currentPerson.sterbedatum_jahr, currentPerson.sterbedatum_monat, currentPerson.sterbedatum_tag)} />
							<DetailElement name="Sterbeort" value={currentPerson.sterbeort} />
							<DetailElement name="Wohnort" value={currentPerson.wohnort} />
							<DetailElementListValues name="Berufe" value={currentPerson.berufe} />
							<DetailElementListValues name="Stellung in der Gemeinde" value={currentPerson.stellungen} />

							<DetailElementPersonWithLink name="Vater" value={currentPerson.vaterPerson} />
							<DetailElementPersonWithLink name="Mutter" value={currentPerson.mutterPerson} />

							<DetailElementChildren name="Ehepartner" value={currentPerson.ehepartnerPersons} />
							<DetailElementChildren name="Kinder" value={currentPerson.kinderPersons} />
							
							
							<hr />
						</div>


						))}

						<Row>
							<Col>
								<hr />
							</Col>
						</Row>
						<DetailElementInscription name="Inschriften" tombstone={tombstone} rights={tombstone.rights} />

						<Row>
							<Col>
								<hr />
							</Col>
						</Row>

						<DetailElement name="Kommentar" value={tombstone.kommentar}>
							<FootnoteLabel
								globalReferences={tombstone.references}
								defaultValue={this.getLinkFromText(tombstone.kommentar)}
							/>
						</DetailElement>
						<DetailElementStylistic name="Stilmittel" value={tombstone.stylistics} inschriften={tombstone.inschriften} />
						<DetailElementZitate name="Zitate" value={tombstone.zitate} inschriften={tombstone.inschriften} />

						
						{tombstone.persons.map((currentPerson, id) => (
							checkDataExist(currentPerson) && checkDataExist(currentPerson.biografie) ? <DetailElementBiografie name={`Zur Biografie:  ${personName(currentPerson)}`} value={this.getLinkFromText(currentPerson.biografie)} rights={currentPerson.rights} /> : null
						))}
						
					


						<DetailElement name="Beschreibung des Grabsteines" value={tombstone.beschreibung}>
							<FootnoteLabel
								globalReferences={tombstone.references}
								defaultValue={tombstone.beschreibung}
							/>
						</DetailElement>
						<DetailElementChoices name="Symbole, Darstellungen" value={tombstone.symboleChoice} />
						{checkDataExist(tombstone.material) ? <DetailElementMaterial name="Material" value={tombstone.material} /> : null}
						{checkDataExist(tombstone.masse) ? <DetailElementMasse name="Maße" value={tombstone.masse} /> : null}
						{checkDataExist(tombstone.herstellerMaker) ? <DetailElement name="Hersteller" value={tombstone.herstellerMaker.displayName} /> : null}

						{checkDataExist(tombstone.literaturList) ? <DetailElementLiteraturListValues name="Literatur zum Grabstein" value={tombstone.literaturList} /> : null}

						{tombstone.persons.map((currentPerson, id) => (
							checkDataExist(currentPerson) && checkDataExist(currentPerson.literatur) ? <DetailElementLiteraturListValues name={`Literatur zur Person: ${personName(currentPerson)}`} value={currentPerson.literatur} /> : null
						))}


						{checkDataExist(tombstone.quelle) ? <DetailElementListValues name="Quellenangaben zum Grabstein" value={tombstone.quelle} /> : null}

						{tombstone.persons.map((currentPerson, id) => (
							checkDataExist(currentPerson) && checkDataExist(currentPerson.quelle) ? <DetailElementListValues name={`Quellenangaben zur Person: ${personName(currentPerson)}`} value={currentPerson.quelle} /> : null
						))}

						<Row>
							<Col>
								<hr />
							</Col>
						</Row>
						{tombstone.references && tombstone.references.length > 0 ? (
							<div>
								<Row >
									<Col><strong>Einzelnachweise:</strong></Col>
								</Row>
								<Row>
									<Col>
										<ReferencesList references={tombstone.references} />
									</Col>
								</Row>
								<Row>
									<Col>
										<ReferencesList references={currentPerson.references} />
									</Col>
								</Row>
								<Row>
									<Col>
										<hr />
									</Col>
								</Row>
							</div>
						) : ""}


						<Row>
							<Col className="col-auto me-auto">
								<a href="/tombstones">zurück zur Liste</a>
							</Col>
							<Col className="col-auto">
								<NavigationButton title="Vorheriger" linkBase="tombstoneDetails" cementryId={cementryId} tombstoneId={previousTombstone} myStyle="btn badge-flat" />
								<NavigationButton title="Nächster" linkBase="tombstoneDetails" cementryId={cementryId} tombstoneId={nextTombstone} myStyle="btn badge-flat" />
							</Col>
							<Col className="col-auto">
								{(ACService.accessValidation(user, Constants.AC_ADMIN_NAVIGATION) || ACService.accessValidation(user, Constants.AC_MANAGER_NAVIGATION)) && (
									<a href={"/management/tombstone/" + cementryId + "/" + tombstoneId} className="btn badge-flat" >Grabstein bearbeiten</a>
								)}
							</Col>
						</Row>
						<Row>
							<Col>

							</Col>
						</Row>
						<Row>


						</Row>
					</div>
					) : (
						<Row>
							<Col>Loading...</Col>
						</Row>
					)}
				</div>
			</Container >
		)
	}
}
